import { get, post } from 'helpers/http.helper'

const Calculations = (() => {
  const getParametersOptions = () =>
    get('rodms/calculations/parameters/options')

  const calculate = (payload, dispatch, action) =>
    post('rodms/calculations', payload, {}, dispatch, action)

  const getPdfFile = ({ id, lang }) =>
    get(`rodms/calculations/${id}?lang=${lang}`, { responseType: 'blob' })

  return {
    getParametersOptions,
    calculate,
    getPdfFile,
  }
})()

export default Calculations
